const DEFAULT_API_BASE_URL =
  process.env.NODE_ENV === 'development' ? '/api' : 'https://authapi.korsmet.shop/api';

export const API_BASE_URL = process.env.KORSMET_API_BASE_URL || DEFAULT_API_BASE_URL;

/**
 * 后端站点根地址（API_BASE_URL 去掉末尾斜杠和 /api 后缀）。
 * OAuth 授权端点要按 `${API_ORIGIN}/api/oauth/authorize` 拼，
 * 此前这段裁剪逻辑在登录页和授权页各写了一份且不完全一致。
 */
export const API_ORIGIN = (() => {
  let base = API_BASE_URL || '';
  if (base.endsWith('/')) {
    base = base.slice(0, -1);
  }
  if (base.endsWith('/api')) {
    base = base.slice(0, -4);
  }
  return base;
})();
